/**
 * SESSION_TIMEOUT is used to hold data in the localStorage (a SessionTimeout object)
 * EXPIRED_SESSION and RENEW_SESSION are used as a custom event names thrown and do not hold any data in storage
 */
export var Auth;
(function (Auth) {
    Auth["ID_TOKEN"] = "kauth";
    Auth["AUTH_ACCESS_TOKEN"] = "kauth_access_token";
    Auth["AUTH_CALLBACK"] = "kauth_callback";
    Auth["AUTH_USER"] = "kauth_user";
    Auth["SESSION_TIMEOUT"] = "session_timeout";
    Auth["EXPIRED_SESSION"] = "expired_session_timeout";
    Auth["RENEW_SESSION"] = "renew_session_timeout";
})(Auth || (Auth = {}));
